import {
	ChangeDetectorRef,
	Component,
	Input,
	OnDestroy,
	OnInit,
} from "@angular/core";
import { RxFormGroup } from "@rxweb/reactive-form-validators";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BroadcastService } from "../../../../../shared/services/broadcast.service";
import { FormService } from "../../../../../shared/services/form.service";
import { ReelsService } from "../../../../../services/reels.service";
import { CopyReelModel } from "../../../../admin/svs/reels/models/copy-reels.model";
import { EventType } from "../../../../../shared/interfaces/event.model";
import { GroupsService } from "../../../../../services/groups.service";
import { ReelCategoriesService } from "../../../../../services/reel-categories.service";
import { LayoutsService } from "../../../../../services/layouts.service";
import { CustomersService } from "../../../../../services/customers.service";

@Component({
	selector: "app-duplicate-reel",
	templateUrl: "./duplicate-reel.component.html",
	styleUrls: ["./duplicate-reel.component.scss"],
})
export class DuplicateReelComponent implements OnInit {
	@Input() data: any = {};
	formGroup: RxFormGroup;
	fields: any = {
		name: {
			type: "input",
			options: {
				path: "name",
				class: "col-sm-12",
				label: {
					text: "Nombre",
					class: "col-sm-12",
				},
			},
		},
		groups_id: {
			type: "select",
			options: {
				path: "groups_id",
				label: {
					text: "Grupo de Autobuses",
				},
				dropdown: {
					text: "Seleccione...",
					options: [],
				},
			},
		},
	};

	selectedGroup = null;
	private atComponentDestroy = new Subject();

	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private reelsService: ReelsService,
		private groupsService: GroupsService,
		private reelCategoriesService: ReelCategoriesService,
		private layoutsService: LayoutsService,
		private customersService: CustomersService,
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data) => {
				this.formGroup = data;
			});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		await this.formService.transformIntoFormGroup(CopyReelModel, this.data);

		const [groups] = await Promise.all([this.groupsService.getAll()]);

		this.fields.groups_id.options.dropdown.options = groups.response;

		this.formGroup.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data) => {
				if (data.groups_id !== null) {
					this.formGroup
						.get("groups_id")
						.setValue(null, { emitEvent: false });
					setTimeout(() => {
						this.formGroup
							.get("groups_id")
							.setValue(data.groups_id, { emitEvent: false });
					});
				}
			});
	}

	/**
	 * Send data to the server
	 */
	submit(): void {
		this.reelsService
			.duplicateReel(this.formGroup, this.data.data.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data) => {
				this.broadcast.reloadDataTable();
				this.broadcast.reloadInit();
				this.modalRef.hide();
			});
	}
}
